/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import RegionContainer from './region/container/RegionContainer';
import ProvinceContainer from './province/container/ProvinceContainer';
import MunicipalityContainer from './municipality/container/MunicipalityContainer';
import BarangayContainer from './barangay/container/BarangayContainer';

function SettingsContainer({ match, pathName }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/general-settings/address/region"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('general-settings/address/region') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Region
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/general-settings/address/province"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('general-settings/address/province') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Province
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/general-settings/address/municipality"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('general-settings/address/municipality') >
                    -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Municipality
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/general-settings/address/barangay"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('general-settings/address/barangay') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Barangay
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/region`} />}
          />
          <Route path={`${match.path}/region`} component={RegionContainer} />
          <Route
            path={`${match.path}/province`}
            component={ProvinceContainer}
          />
          <Route
            path={`${match.path}/municipality`}
            component={MunicipalityContainer}
          />
          <Route
            path={`${match.path}/barangay`}
            component={BarangayContainer}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SettingsContainer);
